import { customerVehiclesReducer } from '@makemydeal/dr-activities-customer-vehicles';
import { customerVehiclesMiddleware } from './config';

export const customerVehiclesConfiguration = {
    middleware: (customerVehiclesMiddleware as any).middleware,
    reducer: customerVehiclesReducer
};
